<template>
  <div class="empty-state w-clearfix w-form">
    <template v-if="tab === 'active'">
      <div class="state-img w-embed">
        <NewOrderInActiveIcon />
      </div>
      <h2 class="h2">Создайте свой первый заказ</h2>
      <div class="text-secondary">
        После создания ваш заказ отобразится в этой вкладке со статусом "В ожидании".
        <br>После одобрения лабораторией, он перейдет в статус в "В работе".
      </div>
      <div class="btn-wrap mt-16">
        <router-link :to="{name: 'new-order'}" class="btn-secondary w-inline-block">
          <div>Создать заказ</div>
        </router-link>
      </div>
    </template>
    <template v-if="role === 'client' && tab === 'completed'">
      <div class="state-img w-embed">
        <NewOrderInCompletedIcon />
      </div>
      <h2 class="h2">У вас нет выполненных заказов</h2>
      <div class="text-secondary">
        После того как клиника выполнит ваш заказ, он отобразится в этой вкладке и вы сможете посмотреть результат работы.
        <br>Если у вас еще нет заказов, самое время его создать
      </div>
      <div class="btn-wrap mt-16">
        <router-link :to="{name: 'new-order'}" class="btn-secondary w-inline-block">
          <div>Создать заказ</div>
        </router-link>
      </div>
    </template>
    <template v-if="role === 'client' && tab === 'rejected'">
      <div class="state-img w-embed">
        <NewOrderInRejectedIcon />
      </div>
      <h2 class="h2">У вас нет отклоненных заказов. И это здорово!</h2>
      <div class="text-secondary">Если по каким-то причинам клиника не может выполнить ваши заказы, они отобразятся в этой вкладке с указанием причины</div>
    </template>

    <template v-else-if="role !== 'client'">
      <div class="state-img w-embed">
        <NoOrdersIcon />
      </div>
      <template v-if="tab === 'new'">
        <h2 class="h2">Нет доступных заказов</h2>
        <div class="text-secondary">
          В системе пока нет новых заказов для вас. Попробуйте обновить эту страницу чуть позже
        </div>
      </template>
      <template v-else-if="tab === 'in_progress'">
        <h2 class="h2">Нет заказов в работе</h2>
        <div class="text-secondary">
          Вы не взяли ни один заказ в работу. Перейдите во вкладку "Новые", чтобы выбрать подходящий заказ для вашей клиники
        </div>
      </template>
      <template v-else-if="tab === 'completed'">
        <h2 class="h2">Нет завершенных заказов</h2>
        <div class="text-secondary">
          Завершите заказы в работе. Для завершения заказа кликните на кнопку "Завершить" и прикрепите файлы результата работы
        </div>
      </template>
      <template v-else-if="tab === 'rejected'">
        <h2 class="h2">Нет отклоненных заказов. Это здорово!</h2>
        <div class="text-secondary">
          Здесь будут выводится отклоненные заказы, если по каким-то причинам вы не можете взять их в работу. Для отклонения заказа нужно нажать на кнопку "Отклонить" и указать причину отклонения
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import NewOrderInActiveIcon from '@/icons/new-order-in-active.svg';
  import NewOrderInCompletedIcon from '@/icons/new-order-in-completed.svg';
  import NewOrderInRejectedIcon from '@/icons/new-order-in-rejected.svg';
  import NoOrdersIcon from '@/icons/no-orders.svg';

  export default {
    name: 'NoOrdersFound',
    components: {
      NewOrderInActiveIcon,
      NewOrderInCompletedIcon,
      NewOrderInRejectedIcon,
      NoOrdersIcon,
    },
    props: {
      tab: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapState({
        role: state => state.auth?.user?.role || '',
      }),
    },
  };
</script>
